<div
  role="dialog"
  aria-labelledby="modalAddEditContactTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalAddEditContactTitle">{{ 'kanban.customerQuickForm.createCustomer' | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-xs-12 col-lg-6 mb-3">
              <label class="form-label">
                {{ 'kanban.customerQuickForm.name' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                [placeholder]="'kanban.customerQuickForm.namePlaceholder' | translate"
              />
              <field-error-component
                [field]="'name'"
                [label]="'kanban.customerQuickForm.name' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-xs-12 col-lg-6 mb-3">
              <label class="form-label">{{ 'kanban.customerQuickForm.email' | translate }}</label>
              <input
                class="form-control"
                maxlength="100"
                formControlName="email"
                [placeholder]="'kanban.customerQuickForm.emailPlaceholder' | translate"
              />
              <field-error-component
                [field]="'email'"
                [label]="'kanban.customerQuickForm.email' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 mb-3">
              <label class="form-label">
                {{ 'kanban.customerQuickForm.phone' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                class="form-control"
                maxlength="25"
                formControlName="phone"
                placeholder="000000000"
                required
                pattern="[0-9]+"
                inputmode="tel"
                maxlength="15"
              />
              <field-error-component
                [field]="'phone'"
                [label]="'kanban.customerQuickForm.phone' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-light" (click)="close()">
          {{ 'kanban.customerQuickForm.close' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">
          {{ 'kanban.customerQuickForm.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
